import { createContext, useContext, useState } from "react";

// Create context
const ToggleContext = createContext(null);

// Provider component
export const ToggleProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);

  console.log("IsOpen", isOpen)

  const toggle = () => setIsOpen((prev) => !prev);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <ToggleContext.Provider
      value={{
        isOpen,
        toggle,
        open,
        close,
      }}
    >
      {children}
    </ToggleContext.Provider>
  );
};

// Custom hook
export const useToggle = () => {
  const context = useContext(ToggleContext);
  if (!context) {
    throw new Error("useToggle must be used inside ToggleProvider");
  }
  return context;
};